export const COOKIE = {
    LANG : "lang",
    REGION : "region",
    CURRENCY : "currency",
    TOKEN : "token"
}

export const LOCALSTORAGE = {
    USER : "user",
    TOKEN : "token",
    USERINDEX : "userIndex",
    PASSWORDLESS_CONFIRM : "passwordless_confirm"
}
